<div class="caja-producto">

  <div class="caja-foto p-1  d-none d-lg-block d-xl-block">
    <img src="{{IMG_URL}}/thumbs/{{articulo.referencia}}.{{IMG_EXTENSION}}" alt="{{articulo.referencia}}" height="80px"
      class="" style="cursor: pointer;" onerror="this.src='assets/img/no-image.png';">
  </div>
  <div class="caja-texto d-flex flex-column justify-content-around p-1">
    <div class="d-flex flex-row justify-content-between align-items-baseline m-1">
      <div title="{{articulo.descripcion}}" class="caja-descripcion caja-lista">
        {{articulo.descripcion}}
      </div>
    </div>

    <div class="tipo-bulto">
      <div>
        {{verLogisticaInfo()}}
      </div>
      @if (!pedidoService.usuario?.impuestos) {
      <div class="caja-precio">
        <div class="importe pr-1">{{articulo.pedcl_imp_final_linea| currency: 'EUR':'symbol':undefined:'es-ES'}}
        </div>
      </div>
      }
      @if (pedidoService.usuario?.impuestos) {
      <div class="caja-precio">
        <div class="importe pr-1">{{articulo.pedcl_imp_final_iva| currency: 'EUR':'symbol':undefined:'es-ES'}}
        </div>
      </div>
      }

    </div>
    <div class="botones-pedido">
      <app-articulo-prop-widget [gridListViene]="true" [articulo]="articulo"></app-articulo-prop-widget>
      @if (articulo.pedcl_cant_ped>0) {
      <div class="caja-compra">
        <div class="buttons-cesta btn btn-sm rounded-circle btn-trash mr-1" (click)=compraCero(articulo)><i
            class="fa fa-trash"></i>
        </div>
        <div class="buttons-cesta btn btn-sm rounded-circle btn-min" (click)=compraMenos(articulo)><i
            class="fa fa-minus"></i>
        </div>
        @if (COMPRA_TB) {
        <div class="buttons-cesta caja-cant text-center p-2" [ngClass]="[classSelUnid()]">
          {{articulo.pedcl_cant_ped}} {{articulo.pedcl_tb_ped |
          tipoBulto:articulo.unid_caja:articulo.unid_frac}} </div>
        }
        <!-- <app-seleccion-cant-articulo *ngIf="COMPRA_TB" [art]="articulo" (confirmEv)="cambiarCantidad(articulo, $event)"
          cant="{{articulo.pedcl_cant_ped}}" tb="{{articulo.pedcl_tb_ped}}" tipoBulto="{{articulo.pedcl_tb_ped |
          tipoBulto:articulo.unid_caja:articulo.unid_frac}}"></app-seleccion-cant-articulo> -->
        @if (!COMPRA_TB) {
        <div class="caja-cant text-center p-2"> {{articulo.pedcl_cant_ped}} </div>
        }
        <div class="buttons-cesta btn btn-sm rounded-circle btn-mas" (click)=compraMas(articulo)><i
            class="fa fa-plus"></i></div>
      </div>
      }
    </div>
  </div>
</div>